export interface CodeSnippetProps {
  identation?: number;
  objects: Array<Object>;
}

export const defaultProps = {
  identation: 2,
};
